import Cookies from 'js-cookie';
import assign from 'lodash/assign';
import merge from 'lodash/merge';
import { Actions, ActionTypes } from '~/types/common';
import { ReduxState } from '~/types/redux';
import { getDefaultState } from '../setup/getInitialState';

const common = (state: ReduxState, action: Actions): ReduxState => {
  switch (action.type) {
    case ActionTypes.SET_TRACKING:
      return merge({}, state, {
        tracking: {
          [action.key]: action.id,
        },
      });
    case ActionTypes.SET_NOTIFICATIONS:
      return assign({}, state, {
        notifications: action.notifications,
      });
    case ActionTypes.SET_PAGE_LOADING:
      return merge({}, state, {
        pageLoading: action.loading,
      });
    case ActionTypes.SET_CALL_IN_NUMBNER:
      return merge({}, state, {
        callInNumber: action.callInNumber,
      });
    case ActionTypes.REMOVE_ACP:
      return assign({}, state, {
        acp: undefined,
      });
    case ActionTypes.REMOVE_QUOTE:
      const tracking = { ...state.tracking };
      delete tracking.quoteId;
      Cookies.remove('quoteId');
      Cookies.remove('quoteCreated');
      return assign({}, state, {
        tracking,
      });
    case ActionTypes.REMOVE_EXPIRATION_BANNER:
      return assign({}, state, {
        expirationBanner: {
          expirationTime: undefined,
          expired: undefined,
        },
      });
    case ActionTypes.SET_MONARCH_DECISION:
      return assign({}, state, {
        monarch: action.payload,
      });
    case ActionTypes.SET_PREAMP_ACTION:
      return merge({}, state, {
        preamp: {
          [action.key]: action.value,
        },
      });
    case ActionTypes.COUNTDOWN_EXPIRATION:
      return assign({}, state, {
        countdownExpiration: action.countdownExpiration,
      });
    case ActionTypes.SET_C2F:
      return merge({}, state, {
        c2f: {
          [action.key]: action.value,
        },
      });
    case ActionTypes.SET_RESUME:
      return merge({}, state, {
        resume: {
          [action.key]: action.value,
        },
      });
    case ActionTypes.SET_AMEX:
      return assign({}, state, {
        amexOffer: true,
      });
    case ActionTypes.SET_EXPIRATION_BANNER:
      return merge({}, state, {
        expirationBanner: {
          [action.key]: action.value,
        },
      });
    case ActionTypes.SET_FEE_CONSENT:
      return assign({}, state, {
        commercialFeeConsent: action.commercialFeeConsent,
      });
    case ActionTypes.SET_CARD_TYPE:
      return assign({}, state, {
        cardType: action.cardType,
      });
    case ActionTypes.SET_COMMERCIAL_CC_FEE:
      return assign({}, state, {
        commercialCreditCardfee: action.commercialCreditCardfee,
      });
    case ActionTypes.SET_COOKIE_PASS:
      return assign({}, state, {
        cookiePass: action.cookiePass,
      });
    case ActionTypes.SET_SESSION_EXPIRED:
      return assign({}, state, {
        sessionExpired: action.expired,
      });
    case ActionTypes.SET_HIDE_FRONTIER_LOGO:
      return assign({}, state, {
        hideFrontierLogo: action.hide,
      });
    case ActionTypes.SET_SINGLE_FORM:
      return merge({}, state, {
        singleForm: {
          [action.key]: action.value,
        },
      });
    case ActionTypes.RESET_SINGLE_FORM:
      return assign({}, state, {
        singleForm: {
          contactCredit: 'inactive',
          installation: 'inactive',
          payment: 'inactive',
          progress: 25,
          dob: '',
        },
      });
    case ActionTypes.SET_HIDE_DEBUG:
      return merge({}, state, {
        hideDebug: action.value,
      });
    case ActionTypes.RESET_STATE:
      const isProd = process.env.environment === 'production';
      return getDefaultState(isProd);
    case ActionTypes.SET_INSTALLATION_OPTIONS:
      return merge({}, state, {
        installationOptions: {
          [action.key]: action.value,
        },
      });
    case ActionTypes.SET_AVAILABILITY:
      return assign({}, state, {
        availability: action.availability,
      });
    case ActionTypes.CLEAR_AVAILABILITY:
      return assign({}, state, {
        availability: undefined,
      });
    case ActionTypes.SET_CUSTOM_OFFERS:
      return merge({}, state, {
        customOffers: {
          [action.key]: action.value,
        },
      });
    case ActionTypes.SET_FIREBASE:
      return assign({}, state, {
        firebase: action.payload,
      });
    case ActionTypes.SET_DISCOUNT_OPTIONS:
      const updatedTracking = [...(state.discountOptions?.tracking || [])];
      action.value.forEach((newOption) => {
        const existingIndex = updatedTracking.findIndex((option) => option.name === newOption.name);
        if (existingIndex !== -1) {
          updatedTracking[existingIndex] = newOption;
        } else {
          updatedTracking.push(newOption);
        }
      });
      return {
        ...state,
        discountOptions: {
          ...state.discountOptions,
          tracking: updatedTracking,
        },
      };
    case ActionTypes.CLEAR_DISCOUNT_OPTIONS:
      return assign({}, state, {
        discountOptions: { tracking: [] },
      });
    case ActionTypes.SET_BUYFLOW_REDIRECT_DELAY:
      return merge({}, state, {
        buyflowRedirectDelay: action.value,
      });
    case ActionTypes.SET_UTM_PARAMS:
      return merge({}, state, {
        utmParams: action.params,
      });
    case ActionTypes.SET_ISP:
      return merge({}, state, {
        isp: action.isp,
      });

    case ActionTypes.SET_CAN_NAVIGATE_TO_BUY_FLOW_REDIRECT:
      return assign({}, state, {
        canNavigateToBuyFlowRedirect: action.canNavigateToBuyFlowRedirect,
      });

    case ActionTypes.SET_CURRENTLY_IN_NGC:
      return assign({}, state, {
        currentlyInNGC: action.value,
      });

    case ActionTypes.SET_OFFER_MERCH_DATA:
      return assign({}, state, {
        offerMerchData: action.data,
      });

    default:
      return state;
  }
};

export default common;
